"use strict";

exports.__esModule = true;
exports.VARIANT = exports.SIZE = exports.PLACEMENT = void 0;
var PLACEMENT = {
  'bottom-end': 'bottom-end',
  'bottom-start': 'bottom-start',
  'top-end': 'top-end',
  'top-start': 'top-start'
};
exports.PLACEMENT = PLACEMENT;
var SIZE = {
  small: 'small',
  medium: 'medium',
  large: 'large',
  jumbo: 'jumbo'
};
exports.SIZE = SIZE;
var VARIANT = {
  danger: 'danger',
  success: 'success',
  warning: 'warning'
};
exports.VARIANT = VARIANT;